import React from 'react'

import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'
import { MonitoringsTaskStatusTagRender } from '@app/components/renderers'

import { CustomEllipsis } from '@app/constants/customEllipsis'

import { columnTitleMap } from '../configs'

import type { Column } from '@app/components/base/Table/types'
import type { ContractorSectionDataSource } from '../types'

const getOptions = (): Array<Column<ContractorSectionDataSource>> => {
  const columnsKeys = Object.keys(columnTitleMap).filter(key => !['status'].includes(key)) as Array<
  keyof ContractorSectionDataSource
  >

  return columnsKeys.map(key => {
    const column: Column<ContractorSectionDataSource> = {
      customEllipsis: CustomEllipsis,
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }

    return column
  })
}

export const getColumns = (): Array<Column<ContractorSectionDataSource>> => {
  return getColumnsFromMap<ContractorSectionDataSource>({
    columnTitleMap,
    options: [
      ...getOptions(),
      {
        key: 'status',
        sorter: (a, b) => sorterDispatcher(a.status, b.status),
        render: (_, { status }) => <MonitoringsTaskStatusTagRender status={ status } />
      }
    ]
  })
}
